<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <a-form layout="inline" class="mb-20">
            <a-form-item label="客户姓名">
                <a-input v-model="dataForm.customer_name" placeholder="客户名称" />
            </a-form-item>
            <a-form-item label="费用名称">
                <a-input v-model="dataForm.external_name" placeholder="费用名称搜索" />
            </a-form-item>
            <a-form-item label="行程名称">
                <a-input v-model="dataForm.trip_name" placeholder="行程名称" />
            </a-form-item>
            <a-form-item label="账户">
                <a-select allowClear :filter-option="filterOption" showSearch v-model="dataForm.account_id"
                    placeholder="请选择" style="width: 160px;">
                    <a-select-option v-for="item in accountList" :key="item.account_id" :value="item.account_id">
                        {{ item.account_name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="类型">
                <a-select v-model="dataForm.pay_type" allowClear style="width: 160px;" placeholder="费用类型选择">
                    <a-select-option value="1">收入</a-select-option>
                    <a-select-option value="2">支出</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="费用渠道">
                <a-select v-model="dataForm.channel" allowClear style="width: 160px;" placeholder="费用渠道选择">
                    <a-select-option value="1">客户收付款</a-select-option>
                    <a-select-option value="2">利润额外费用</a-select-option>
                    <a-select-option value="3">供应商收付款</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="是否核对">
                <!-- 核对状态1待核对2核对通过3核对不通过 -->
                <a-select v-model="dataForm.process_status" allowClear style="width: 160px;" placeholder="是否核对">
                    <a-select-option value="1">待核对</a-select-option>
                    <a-select-option value="2">核对通过</a-select-option>
                    <a-select-option value="3">核对不通过</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="交易时间">
                <a-range-picker @change="onChangeTime2" allowClear value-format="yyyy/MM/DD" />
            </a-form-item>
            <a-form-item>
                <a-button @click="getDataList" type="primary">查询</a-button>
            </a-form-item>
            <a-form-item>
                <a-button @click="batchHedui()" type="primary">批量核对</a-button>
            </a-form-item>
        </a-form>
        <a-table class="mb-24" :scroll="{ x: 1500 }" :columns="columns" :data-source="dataList" :pagination="false"
            rowKey="external_id" :loading="dataListLoading"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
            <!-- <template slot="footer" slot-scope="currentPageData">
                <a-statistic title="合计金额：" :value="totalMoney" />
            </template> -->
            <template slot="trip" slot-scope="trip, row">
                <a-button type="link" @click="TripProjectClick(trip.trip_id)">
                    {{ trip.customerinfo.customer_name }}</a-button>
                <!-- <p>行程： {{ trip.trip_name }}</p> -->
            </template>
            <template slot="pay_type_text" slot-scope="pay_type_text, row">
                <a-tag :color="row.pay_type == 1 ? 'green' : 'red'">{{
                    pay_type_text
                }}</a-tag>
            </template>
            <template slot="process_status_text" slot-scope="process_status_text, row">
                <a-tag :color="row.process_status == 1 ? 'blue' : row.process_status == 2 ? 'green' : 'red'">{{
                    process_status_text
                }}</a-tag>
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a-space :size="15">
                    <a class="btn-edit" @click="shoukuanshenhe([row.external_id])"
                        v-permission="['admin:tripexternal:receivePaymentExamineResult']">
                        费用核对
                    </a>
                    <a class="btn-edit" style="color: red;" v-if="row.process_status == 3"
                        v-permission="['admin:tripexternal:resetExamine']"
                        @click="shoukuanshenheAgain(row.external_id)">
                        重新核对
                    </a>
                    <a class="btn-edit" @click="showPaymentHandle(row.external_id)"
                        v-permission="['admin:tripexternal:detail']">
                        查看
                    </a>
                    <a class="btn-edit" @click="addOrUpdatePaymentHandle(row.external_id)"
                        v-permission="['admin:tripexternal:update']">
                        编辑
                    </a>
                    <a class="btn-edit" @click="deleteHandle(row.external_id)"
                        v-permission="['admin:tripexternal:delete']">
                        删除
                    </a>
                </a-space>
            </template>
        </a-table>
        <a-pagination class="mr-20 float-right" :current="page" :total="total" :show-total="(total) => `共 ${total} 条数据`"
            @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
        <shoukuan ref='shoukuan' @ok="getDataList"></shoukuan>
        <examine ref="examine" @ok="getDataList"></examine>
        <TripProject ref="tripProject"></TripProject>
    </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import shoukuan from "@/components/TripProject/shoukuan.vue";
import examine from './examine.vue'
import TripProject from "@/components/TripProject/index.vue";
export default {
    mixins: [viewModule],
    components: {
        shoukuan,
        examine,
        TripProject
    },
    data() {
        return {
            selectedRowKeys: [],
            dataForm: {
                trip_id: '',
                trip_name: "",
                customer_name: "",
                pay_type: undefined,//费用类型
                channel: undefined, //费用渠道1客户收付款 2利润额外费用（手续费）3对供应商收付款
                external_name: null, //费用名称
                process_status: '1',//核对状态
                account_id: undefined,//账户
            },
            columns: [
                {
                    title: "客户名称",
                    dataIndex: "trip",
                    width: 150,
                    scopedSlots: { customRender: "trip" },
                },
                {
                    title: "费用名称",
                    dataIndex: "external_name",
                    width: 150,
                    // customRender: (text) => text.substr(0, 11),
                },
                {
                    title: "类型",
                    dataIndex: "pay_type_text",
                    width: 150,
                    scopedSlots: { customRender: "pay_type_text" },
                },
                {
                    title: "费用渠道",
                    dataIndex: "channel_text",
                    width: 200,
                },
                {
                    title: "账户",
                    dataIndex: "account.account_name",
                    width: 200,
                },
                {
                    title: "金额",
                    dataIndex: "external_total",
                    width: 200,
                },
                {
                    title: "交易时间",
                    dataIndex: "external_receivetime",
                    width: 200,
                },
                {
                    title: "提交人",
                    dataIndex: "user.real_name",
                    width: 200,
                },
                {
                    title: "核对状态",
                    dataIndex: "process_status_text",
                    scopedSlots: { customRender: "process_status_text" },
                    width: 100,
                    fixed: "right",
                },
                {
                    title: "核对拒绝原因",
                    dataIndex: "process_reason",
                    width: 150,
                    fixed: "right",
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    width: 350,
                    fixed: "right",
                },
            ],
            mixinViewModuleOptions: {
                createdIsNeed: false,
                getDataListURL: "/admin/tripexternal/page",
                deleteURL: "/admin/tripexternal/delete",
            },
            totalMoney: "",
            accountList: []
        };
    },
    created() {
        const user_id = this.$route.query.user_id;
        const process_status = this.$route.query.process_status;
        if (user_id) {
            this.dataForm.user_id = user_id;
        }
        if (process_status) {
            this.dataForm.process_status = process_status;
        }
        this.query()
    },
    mounted() {
        this.$http({
            url: "/admin/account/select",
            method: "get",
        }).then(res => {
            this.accountList = res.data
        })
    },
    methods: {
        batchHedui() {
            if(this.selectedRowKeys.length == 0) return this.$message.error('至少选择一条核对的项')
            this.$refs.examine.init(this.selectedRowKeys)
        },
        onSelectChange(selectedRowKeys) {
            console.log('selectedRowKeys changed: ', selectedRowKeys);
            this.selectedRowKeys = selectedRowKeys;
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        onChangeTime2(e) {
            if (e.length == 2) {
                this.dataForm.time_start = `${e[0]} 00:00:00`
                this.dataForm.time_end = `${e[1]} 23:59:59`
            } else {
                this.dataForm.time_start = undefined
                this.dataForm.time_end = undefined
            }
        },
        addOrUpdatePaymentHandle(external_id) {
            this.$refs.shoukuan.init({ external_id });
        },
        showPaymentHandle(external_id) {
            this.$refs.shoukuan.read({ external_id });
        },
        queryAfter(e) {
            this.totalMoney = e.data.totalMoney
        },
        //费用核对
        shoukuanshenhe(external_id) {
            this.$refs.examine.init(external_id)
        },
        //重新核对
        shoukuanshenheAgain(external_id) {
            this.$confirm({
                title: '是否已修改完毕交易信息?',
                content: '确认后将再次提交给财务核对',
                onOk: () => {
                    this.$http({
                        url: '/admin/tripexternal/resetExamine',
                        method: 'post',
                        data: {
                            external_id
                        }
                    }).then(() => {
                        this.$message.success('重新发起核对成功')
                        this.query()
                    })
                },
            });
        },
        TripProjectClick(trip_id) {
            this.$refs.tripProject.init(trip_id);
        },
    }
};
</script>

<style></style>